// Videos with .lazy-video only get their src when they approach the viewport,
// and play only while visible, so they don't download on page load.
export function initLazyVideos() {
    const videos = document.querySelectorAll("video.lazy-video[data-src]");
    if (!videos.length) return;

    if (!("IntersectionObserver" in window)) {
        for (const video of videos) loadVideo(video);
        return;
    }

    const loader = new IntersectionObserver((entries) => {
        for (const entry of entries) {
            if (entry.isIntersecting) {
                loadVideo(entry.target);
                loader.unobserve(entry.target);
            }
        }
    }, {rootMargin: "300px 0px"});

    const player = new IntersectionObserver((entries) => {
        for (const entry of entries) {
            const video = entry.target;
            if (entry.isIntersecting && video.src) {
                video.play().catch(() => {});
            } else {
                video.pause();
            }
        }
    }, {threshold: 0.25});

    for (const video of videos) {
        loader.observe(video);
        player.observe(video);
    }
}

function loadVideo(video) {
    if (video.src) return;
    video.preload = "auto";
    video.src = video.dataset.src;
    video.addEventListener("canplay", () => {
        const rect = video.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
            video.play().catch(() => {});
        }
    }, {once: true});
}
